import { DeclarationStatus } from '@enums/declaration-status.enum';
import { StatusColor } from '@enums/status-color.enum';

export const DECLARATION_STATUS_COLOR: Record<DeclarationStatus, StatusColor> = {
  [DeclarationStatus.sentWithoutTeletransmission]: StatusColor.accent,
  [DeclarationStatus.accepted]: StatusColor.accent,
  [DeclarationStatus.done]: StatusColor.accent,
  [DeclarationStatus.sent]: StatusColor.accent,
  [DeclarationStatus.transmitted]: StatusColor.accent,
  [DeclarationStatus.readyToBeSent]: StatusColor.accent,
  [DeclarationStatus.refused]: StatusColor.warn,
  [DeclarationStatus.declined]: StatusColor.warn,
  [DeclarationStatus.docRequested]: StatusColor.warn,
  [DeclarationStatus.toCheck]: StatusColor.orange,
  [DeclarationStatus.toVerify]: StatusColor.orange,
  [DeclarationStatus.toCorrect]: StatusColor.orange,
  [DeclarationStatus.toFix]: StatusColor.orange,
  [DeclarationStatus.toSupervise]: StatusColor.orange,
  [DeclarationStatus.waitingClient]: StatusColor.orange,
  [DeclarationStatus.toBeReturned]: StatusColor.orange,
  [DeclarationStatus.clientValidationRequested]: StatusColor.orange,
  [DeclarationStatus.preDraft]: StatusColor.grey3,
  [DeclarationStatus.draft]: StatusColor.grey3,
  [DeclarationStatus.toDo]: StatusColor.grey3,
  [DeclarationStatus.ignored]: StatusColor.grey4
};
